"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isServerRenderResult(testValue) {
  return !!(testValue.renderedHtml || testValue.redirectLocation || testValue.routeError || testValue.error);
}
exports["default"] = isServerRenderResult;